import React, { useState, useEffect, useRef } from 'react';
import { Modal, Banner, IndexFilters, IndexTable, Text, Thumbnail, Pagination, ChoiceList, Tabs } from "@shopify/polaris";
import { NoteIcon } from "@shopify/polaris-icons";
import {
    reqGetOnPageList,
} from '../../api';

import "./index.scss";
import Langauge from "../../i18n/Language";
import { cloneDeep, debounce } from 'lodash-es';
import FooterPageSelect from '../../components/FooterPageSelect/indexPage';

const t = Langauge;

const PagesModal = (props) => {

    const {
        openState,
        selectPageIdArr,
    } = props;

    const productStatusData = [{
        label: t('Active'),
        value: 'Active',
    }, {
        label: t('Draft'),
        value: 'Draft',
    }, {
        label: t('Unlisted'),
        value: 'Unlisted',
    }];

    const visibleData = [{
        value: 1,
        label: t("Visible"),
    }, {
        value: 0,
        label: t("Hidden"),
    }];

    const [pagesModalOpen, setPagesModalOpen] = useState(false);
    const [sortSelected, setSortSelected] = useState(['order desc']);
    const [queryValue, setQueryValue] = useState('');
    const [selected, setSelected] = useState(0);
    const [mode, setMode] = useState('FILTERING'); // DEFAULT || FILTERING 
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(5);
    const [total, setTotal] = useState(0);
    const [pagesList, setPagesList] = useState([]);
    const [tableLoading, setTableLoading] = useState(true);
    const [hasPrevious, setHasPrevious] = useState(false);
    const [hasNext, setHasNext] = useState(false);
    const [current_PageSize, setCurrentPageSize] = useState(5);
    const [productStatus, setProductStatus] = useState(['Active']);
    const [visibleStatus, setVisibleStatus] = useState([1]);
    const [selectedResources, setSelectedResources] = useState([]);
    const [allResourcesSelected, setAllResourcesSelected] = useState(false);
    const [allSelectNum, setAllSelectNum] = useState(0);
    const [selectIdArr, setSelectIdArr] = useState({
        product: [],
        blog: [],
        collections: [],
        homepage: [],
        otherpage: [],
    });
    const [blogIdArr, setBlogIdArr] = useState({});
    const [errorMsg, setErrorMsg] = useState({
        msg: '',
        status: 'warning',
    });

    // 标题
    const tabs = [
        { title: "Products" },
        { title: "Blog posts" },
        { title: "Collections" },
        { title: "Homepage" },
        { title: "Other Pages" }
    ].map((item, index) => ({
        index,
        id: `${item.title}-${index}`,
        content: t(item.title),
        onAction: () => { },
    }));

    // 获取页面列表 - 接收所有参数，不依赖外部状态
    const getPagesList = async (options = {}) => {
        const {
            _page = 1,
            _size = 5,
            _query = '',
            _selected = selected,
            _productStatus = productStatus,
            _visibleStatus = visibleStatus,
        } = options;

        setErrorMsg({ msg: '', status: 'warning' });
        // Homepage 固定数据
        if (_selected === 3) {
            setPagesList([{ id: 1, title: "Home Page", imgsrc: "" }]);
            setTotal(1);
            setHasPrevious(false);
            setHasNext(false);
            setTableLoading(false);
            const _id = selectIdArr.homepage;
            setSelectedResources(_id);
            setAllResourcesSelected(_id.length === 1);
            return;
        }

        setTableLoading(true);
        // 当前tab
        let currentTab = _selected === 0 ? 'product' : _selected === 1 ? 'blog' : _selected === 2 ? 'collections' : _selected === 4 ? 'otherpage' : 'product';
        // 当前tab数量
        let currentTabNum = selectIdArr[currentTab].length;
        const params = {
            page: _page,
            size: _size,
            q: _query,
            selectId: 0,
            type: currentTab,
        };

        if (_selected === 0 && _productStatus.length > 0) {
            params.productsStatus = _productStatus;
        }
        if (_selected !== 0 && _selected !== 3 && _visibleStatus.length > 0) {
            params.selectedActive = _visibleStatus[0] === 1 ? 'Active' : 'Hidden';
        }

        const res = await reqGetOnPageList(params);
        if (res.ack === 1) {
            setPagesList(res.data.result);
            setTotal(res.data.count);
            setHasPrevious(_page > 1);
            setHasNext(_page * _size < res.data.count);
            setTableLoading(false);
            if (currentTab === 'blog') {
                const blogSelected = selectIdArr.blog || [];
                // 把选中项里的 article_id 统一替换成对应的 id（该 id 尚未被选中时才替换，避免重复）
                const articleIdToId = new Map();
                res.data.result.forEach(item => {
                    if (!blogSelected.includes(item.id)) {
                        articleIdToId.set(item.article_id, item.id);
                    }
                });
                const _selectArr = blogSelected.map(sel => articleIdToId.get(sel) ?? sel);
                setSelectIdArr({ ...selectIdArr, blog: _selectArr });
                setSelectedResources(_selectArr);
            } else if (currentTab === 'product') {
                let c_selectArr = selectIdArr.product;
                setSelectIdArr(selectIdArr);
                setSelectedResources(c_selectArr);
            } else {
                setSelectedResources(selectIdArr[currentTab]);
            }
            setAllResourcesSelected(currentTabNum === res.data.count);
            let _blogIdArr = cloneDeep(blogIdArr);
            if (currentTab === 'blog') {
                (res.data.result).forEach(item => {
                    _blogIdArr[item.id] = item.article_id;
                })
                setBlogIdArr(_blogIdArr);
            }
        } else {
            setErrorMsg({ msg: res.msg, status: 'critical' });
            setTableLoading(false);
        }
    };

    // 防抖搜索 - 使用 ref 保持稳定，内部通过闭包获取最新状态
    const debouncedSearch = useRef(
        debounce((value, currentSelected, currentProductStatus, currentVisibleStatus) => {
            getPagesList({
                _page: 1,
                _size: 5,
                _query: value,
                _selected: currentSelected,
                _productStatus: currentProductStatus,
                _visibleStatus: currentVisibleStatus,
            });
        }, 500)
    ).current;

    // 保存
    const handleSaveSelect = () => {
        // 需要格式化博客id
        let _newArr = cloneDeep(selectIdArr);
        if (_newArr.blog.length > 0) {
            _newArr.blog.forEach((item, index) => {
                if (blogIdArr[item]) {
                    _newArr.blog[index] = blogIdArr[item];
                }
            })
        }
        props.handleGetSelectId(_newArr);
        handleCancelSelect();
    }

    // 取消
    const handleCancelSelect = () => {
        setPagesModalOpen(false);
        props.onClose();
    }

    // 创建新视图
    const onCreateNewView = async (value) => {
        return value;
    };

    // 分页
    const changePageTable = (p) => {
        setPage(p);
        getPagesList({ _page: p, _size: size, _query: queryValue });
    };

    // 切换每页数量
    const changePageSize = (s) => {
        setPage(1);
        setSize(s);
        setCurrentPageSize(s);
        getPagesList({ _page: 1, _size: s, _query: queryValue });
    };

    // 系统分页
    const handlePageBlur = (e) => {
        setPage(Number(e));
        getPagesList({ _page: Number(e), _size: size, _query: queryValue });
    };

    // 输入搜索内容（防抖）
    const handleQueryValueChange = (value) => {
        setQueryValue(value);
        debouncedSearch(value, selected, productStatus, visibleStatus);
    };

    // 产品状态筛选
    const handleProductStatusChange = (value) => {
        setProductStatus(value);
        setPage(1);
        getPagesList({ _page: 1, _size: size, _query: queryValue, _productStatus: value });
    };

    const handleProductStatusRemove = () => {
        setProductStatus([]);
        setPage(1);
        getPagesList({ _page: 1, _size: size, _query: queryValue, _productStatus: [] });
    };

    // 可见状态筛选
    const handleVisibleChange = (value) => {
        setVisibleStatus(value);
        setPage(1);
        getPagesList({ _page: 1, _size: size, _query: queryValue, _visibleStatus: value });
    };

    const handleVisibleRemove = () => {
        setVisibleStatus([]);
        setPage(1);
        getPagesList({ _page: 1, _size: size, _query: queryValue, _visibleStatus: [] });
    };

    // 清除所有过滤条件
    const handleFiltersClearAll = () => {
        setQueryValue('');
        setProductStatus([]);
        setVisibleStatus([]);
        setPage(1);
        getPagesList({ _page: 1, _size: size, _query: '', _productStatus: [], _visibleStatus: [] });
    };

    // 取消筛选
    const onHandleCancel = () => {
        if (queryValue || productStatus.length > 0 || visibleStatus.length > 0) {
            handleFiltersClearAll();
        }
    };

    // 切换 Tab 时重置并获取数据
    const handleTabChange = (newSelected) => {
        setSelected(newSelected);
        setPage(1);
        setSize(5);
        setCurrentPageSize(5);
        setQueryValue('');
        setMode('FILTERING');
        setProductStatus(['Active']);
        setVisibleStatus([1]);
        // 直接用新的 tab 值请求
        getPagesList({
            _page: 1,
            _size: 5,
            _query: '',
            _selected: newSelected,
            _productStatus: ['Active'],
            _visibleStatus: [1],
        });
    };

    // 选择资源
    const handleSelectionChange = (p, e, i) => {
        if (tableLoading) {
            return;
        }
        const typeObj = ["product", "blog", "collections", "homepage", "otherpage"];
        let newSelArr = cloneDeep(selectIdArr);
        let _sel = newSelArr[typeObj[selected]];
        if (p === "page") {
            // 全选
            let idArr = pagesList.map(item => item.id);
            // 判断_sel是否包含idArr
            if (e) {
                let existLens = idArr.filter(item => _sel.includes(item)).length;
                _sel = existLens === idArr.length ? _sel.filter(item => !idArr.includes(item)) : [..._sel, ...idArr];
            } else {
                _sel = _sel.filter(item => !idArr.includes(item));
            }
        } else {
            // 单选
            if (_sel.includes(i)) {
                _sel = _sel.filter(item => item !== i);
            } else {
                _sel.push(i);
            }
        }
        // 去重
        _sel = [...new Set(_sel)];
        newSelArr[typeObj[selected]] = _sel;
        let count = Object.keys(newSelArr).reduce((acc, curr) => acc + newSelArr[curr].length, 0);
        if (count > 10) {
            setErrorMsg({ msg: t("Select up to {{v1}} pages", 10), status: 'warning' });
        } else {
            setErrorMsg({ msg: '', status: 'warning' });
            setSelectedResources(_sel);
            setAllResourcesSelected(_sel.length === total);
            setAllSelectNum(count);
            setSelectIdArr(newSelArr);
        }

    }

    // 清理 debounce
    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
            // 重置参数
            setSelected(0);
            setProductStatus(['Active']);
            setVisibleStatus([1]);
            setQueryValue('');
            setMode('FILTERING');
            setPage(1);
            setSize(5);
            setCurrentPageSize(5);
        }
    }, []);

    // 弹窗打开时获取数据
    useEffect(() => {
        setPagesModalOpen(openState);
        if (openState) {
            getPagesList({ _page: page, _size: size, _query: queryValue });
        }
    }, [openState]);

    useEffect(() => {
        let count = selectPageIdArr?.product ? Object.keys(selectPageIdArr).reduce((acc, curr) => acc + selectPageIdArr[curr].length, 0) : 0;
        setAllSelectNum(count);
        setSelectIdArr(selectPageIdArr);
    }, [selectPageIdArr]);

    const resourceName = {
        singular: t('data'),
        plural: t('datas'),
    };

    // 分页
    const footerContentMsg = <FooterPageSelect
        isLess={true}
        page={page}
        current_PageSize={current_PageSize}
        total={total}
        changePageSize={changePageSize}
        handlePageBlur={handlePageBlur}
        tableLoading={tableLoading}
    />

    // 过滤
    const filters = selected === 0 ? [
        {
            key: 'Statuses',
            label: t("Product Status"),
            filter: (
                <ChoiceList
                    title={t("Product Status")}
                    titleHidden
                    choices={productStatusData}
                    selected={productStatus || []}
                    onChange={handleProductStatusChange}
                    allowMultiple
                />
            ),
            shortcut: true,
            pinned: true,
        },
    ] : selected !== 3 ? [
        {
            key: 'Visibility',
            label: t("Visibility"),
            filter: (
                <ChoiceList
                    title={t("Visibility")}
                    titleHidden
                    choices={visibleData}
                    selected={visibleStatus || []}
                    onChange={handleVisibleChange}
                    allowMultiple={false}
                />
            ),
            shortcut: true,
            pinned: true,
        }
    ] : [];

    // 应用过滤
    const appliedFilters = [];
    if (productStatus && !isEmpty(productStatus)) {
        const key = 'Statuses';
        appliedFilters.push({
            key,
            label: disambiguateLabel(key, productStatus),
            onRemove: handleProductStatusRemove,
        });
    }
    if (visibleStatus && !isEmpty(visibleStatus)) {
        const key = 'Visibility';
        appliedFilters.push({
            key,
            label: disambiguateLabel(key, visibleStatus),
            onRemove: handleVisibleRemove,
        });
    }
    const rowMarkup = pagesList.map(
        (
            { id, title, imgsrc },
            index,
        ) => (
            <IndexTable.Row
                id={id}
                key={id}
                selected={selectedResources.includes(id)}
                position={index}
            >
                <IndexTable.Cell>
                    <div className='flex_layout g_product_title'>
                        <Thumbnail
                            source={imgsrc ? `${imgsrc.slice(0, imgsrc.lastIndexOf('.'))}_thumb${imgsrc.slice(imgsrc.lastIndexOf('.'))}` : NoteIcon}
                            size="small"
                            alt=""
                        />
                        <Text variant="bodyMd" as="p">
                            {title}
                        </Text>
                    </div>
                </IndexTable.Cell>
            </IndexTable.Row>
        ),
    );

    // 页面弹窗
    const pageModalContent = <Modal
        open={pagesModalOpen}
        title={t("Select relevant pages to link in your blog post")}
        primaryAction={{
            // content: t("Save"),
            content: t("Insert {{v1}} links", allSelectNum),
            onAction: handleSaveSelect,
            disabled: tableLoading || (allSelectNum > 10)
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: handleCancelSelect,
                disabled: tableLoading
            }
        ]}
        onClose={handleCancelSelect}
    >
        {
            Boolean(errorMsg?.msg) && <Modal.Section>
                <Banner
                    tone={errorMsg?.status}
                    title={t(errorMsg?.msg)}
                ></Banner>
            </Modal.Section>
        }
        <div className='pages_modal_content' key={`${mode}_filter_${selected}`}>
            <div className={`fake_tabs ${(mode === 'FILTERING') ? 'active' : ''}`}>
                <Tabs tabs={[
                    { id: 0, content: t("Products") },
                    { id: 3, content: t("Blog posts") },
                    { id: 2, content: t("Collections") },
                    { id: 1, content: t("Homepage") },
                    { id: 4, content: t("Other Pages") },
                ]} selected={selected} onSelect={handleTabChange}></Tabs>
            </div>
            <IndexFilters
                sortOptions={false}
                sortSelected={sortSelected}
                queryValue={queryValue}
                queryPlaceholder={t("Searching in all")}
                onQueryChange={handleQueryValueChange}
                onQueryClear={() => handleQueryValueChange('')}
                onSort={setSortSelected}
                primaryAction={false}
                cancelAction={{
                    onAction: onHandleCancel,
                    disabled: false,
                    loading: false,
                }}
                tabs={tabs}
                selected={selected}
                onSelect={handleTabChange}
                canCreateNewView={false}
                onCreateNewView={onCreateNewView}
                filters={filters}
                appliedFilters={appliedFilters}
                hideFilters={selected === 3}
                hideQueryField={selected === 3}
                onClearAll={handleFiltersClearAll}
                mode={mode}
                setMode={setMode}
                autoFocusSearchField={false}
                closeOnChildOverlayClick={true}
            />
            <IndexTable
                loading={tableLoading}
                resourceName={resourceName}
                itemCount={total}
                selectedItemsCount={
                    allResourcesSelected ? 'All' : selectedResources.length
                }
                onSelectionChange={handleSelectionChange}
                headings={[
                    { title: t("Title") },
                ]}
                selectable={true}
            >
                {rowMarkup}
            </IndexTable>
        </div>
        {
            Boolean(pagesList.length > 0 && selected !== 3) && <div className={`justify_center`}>
                <Pagination
                    label={footerContentMsg}
                    hasPrevious={hasPrevious && !tableLoading}
                    onPrevious={() => changePageTable(page - 1)}
                    hasNext={hasNext && !tableLoading}
                    onNext={() => changePageTable(page + 1)}
                />
            </div>
        }
    </Modal>

    return pageModalContent;

    function disambiguateLabel(key, value) {
        switch (key) {
            case 'Statuses':
                let productStatusTag = productStatusData.filter(i => value.includes(i.value));
                let productStatusTagText = '';
                productStatusTag.forEach((c, i) => {
                    productStatusTagText += (i === (value.length - 1)) ? `${c.value}` : `${c.value}, `;
                })
                return `${t("Product Status")}: ${productStatusTagText}`;
            case 'Visibility':
                let visibleTag = visibleData.filter(i => i.value === value[0]);
                let tagText = visibleTag.length > 0 ? visibleTag[0]['label'] : '';
                return `${t("Visibility")}: ${tagText}`;
            default:
                return value;
        }
    }

    function isEmpty(value) {
        if (Array.isArray(value)) {
            return value.length === 0;
        } else {
            return value === '' || value == null;
        }
    }
};

export default PagesModal;